module.exports = __webpack_public_path__ + "static/media/113-greenland.acea9e99.svg";